import CookieSettingsModal from './CookieSettingsModal';

export default CookieSettingsModal;
